import { NativeDisplayBuilder } from './NativeDisplayBuilder';

const nativeDisplayBuilder = (
  reactDirective,
  $modal,
  $rootScope,
  CreativeService,
  OpenGraphDataService,
  RenderService
) => {
  return reactDirective(
    NativeDisplayBuilder,
    undefined,
    {
      restrict: 'E'
    },
    {
      $modal,
      $rootScope,
      CreativeService,
      OpenGraphDataService,
      RenderService
    }
  );
};

nativeDisplayBuilder.$inject = [
  'reactDirective',
  '$modal',
  '$rootScope',
  'CreativeService',
  'OpenGraphDataService',
  'RenderService'
];

export { nativeDisplayBuilder };
